import { useEffect } from 'react';
import { useTimestamp } from './useTimestamp';
import { throttle, isUndefined } from 'lodash';
export function useThrottledEventRefresher(wait, ...props) {
    const { setCurrentTimestamp } = useTimestamp();
    useEffect(() => {
        const throttledChangeTimestamp = throttle(setCurrentTimestamp, wait);
        const unRegisters = props.filter(prop => !isUndefined(prop)).map(prop => {
            return prop.reo(throttledChangeTimestamp);
        });
        // Call set current timestamp to make sure we're refreshed when `props` are changed
        setCurrentTimestamp();
        return () => {
            unRegisters.forEach(unRegister => unRegister());
        };
    }, props);
}
//# sourceMappingURL=useThrottledEventRefresher.js.map